import { Typography } from '@mui/material';

import DOMPurify from 'dompurify';

import { IEntityDetailsProps } from '../../../api/type-def';

import styles from './Overview.module.scss';

const Description = ({ entityData }: IEntityDetailsProps) => {
	let value = 'No Data Found';
	entityData?.forEach((res: any) => {
		if (res.label === 'Description') {
			value = res.value || 'NA';
		}
	});
	const newlineText = value?.replace(/\n/g, '<br />');

	return (
		<div data-testid="desc-container">
			{entityData && (
				<Typography className={styles['desc-text']}>
					<div
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(newlineText),
						}}
					/>
				</Typography>
			)}
		</div>
	);
};

export default Description;
